export enum WebhookEvent {
  PreUserAdd = 1,
  PostUserAdd = 2,
}